<template>
    <modal
        name="article-modal"
        :pivotY="0.1"
        :adaptive="true"
        :height="'auto'"
        :scrollable="true"
        :clickToClose="false"
        @before-open="onModalShow"
    >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Titolo news</label>
                                    <input type="text" name="article_name" v-model="article.title" class="form-control" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Contenuto news</label>
                                    <my-editor v-model="article.body" />
                                </div>
                            </div>
                        </div>
                        <div v-if="$v.$error" class="alert alert-danger mb-0">
                            <span v-if="!$v.article.article_name.required">É richiesta almento una tratta per creare una missione.<br></span>
                            <span v-if="!$v.article.article_company.required">Un utente a cui assegnare la missione è richiesta.<br></span>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="submit" class="btn btn-success" @click="saveArticle">
                            <font-awesome-icon :icon="['far','save']"></font-awesome-icon>&nbsp;SALVA
                        </button>
                        <button type="button" class="btn btn-light" @click="closeModal">
                            <font-awesome-icon icon="times"></font-awesome-icon>&nbsp;CHIUDI
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import {
    required
} from 'vuelidate/lib/validators'
import {
    mapGetters
} from 'vuex'
import {
    CREATE,
    UPDATE
} from '@/store/actions.type'
import {
    MODULE_NAME as ARTICLES_MODULE_NAME
} from '@/store/modules/articles.module'
// import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import MyEditor from './MyEditor'
export default {
    name: 'article-modal',
    props: {
        article: {
            type: Object
        }
    },
    // mounted () {
    //     console.log(this.article)
    // },
    validations: {
        article: {
            title: {
                required
            }
        }
    },
    computed: {
        ...mapGetters([
            'currentUser'
        ])
    },
    methods: {
        closeModal () {
            this.$modal.hide('article-modal')
        },
        onModalShow () {
            this.$v.$reset()
        },
        saveArticle () {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                const ACTION = this.article.id ? UPDATE : CREATE
                this.article.author = this.currentUser.id
                this.$store.dispatch(`${ARTICLES_MODULE_NAME}/${ACTION}`, this.article).then((result) => {
                    if (result.status === 200) {
                        this.$swal('Ben fatto!', '', 'success')
                        this.$emit('new-article-created')
                        this.closeModal()
                    }
                })
            }
        }
    },
    // watch: {
    //     'article.body' (newVal) {
    //         console.log(JSON.stringify(newVal))
    //     }
    // },
    components: {
        MyEditor
    }
}
</script>
<style lang="scss">
.v--modal {
    overflow: visible !important;
}
</style>
